import PhoneNumberCallAction from './PhoneNumberCallAction';
export default PhoneNumberCallAction;